<template>
    <section class="section section-white content-padded" onload="init()">
        <el-card header="视频上传" shadow="never" v-loading="loader">
            <el-form ref="form" :model="form" label-width="110px">
                <el-form-item label="视频上传者">
                    <el-input v-model="form.nickname" placeholder="视频上传者" style="width: 55%;" disabled=""></el-input>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model="form.title" placeholder="标题" style="width: 55%;"></el-input>
                </el-form-item>
                <el-form-item class="content-left"  label="类型">
                   <el-radio-group v-model="type"  @change="typeSel" size="small">
                     <el-radio label="1" border>普通视频</el-radio>
                     <el-radio label="2" border>短视频</el-radio>
                   </el-radio-group>
                </el-form-item>
                <el-form-item label="分类">
                    <el-select size="small" v-model="form.cate_id" clearable placeholder="请选择直播分类">
                        <el-option v-for="item in category" :key="item.value" :label="item.cate_name" size="mini" :value="item.cate_id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="主讲人">
                    <el-input v-model="form.speaker" placeholder="张三" style="width: 55%;"></el-input>
                </el-form-item>
                <el-form-item label="主讲人简介">
                    <el-input v-model="form.speaker_desc" placeholder="XX专家" style="width: 55%;"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="form.sort" placeholder="0" style="width: 55%;"></el-input>
                </el-form-item>
                <el-form-item label="视频简介">
                    <el-input v-model="form.description" placeholder="简介" style="width: 55%;"></el-input>
                </el-form-item>
                <el-form-item label="视频详情">
                    <!-- <quill-editor ref="text" v-model="form.content" class="myQuillEditor"  style="width: 55%;" /> -->
                    <vue-html5-editor :content="form.content" ref="editor" style="width: 55%;" @change="updateContent" :height="360"></vue-html5-editor>
                    <span class="tpl_item img" @click="addImgPreview" style="">
                      <i class="iconfont icon-image"></i>图片
                    </span>
                    <imgPicker :dialog-visible="thumbDialog" :sc-status="isGetThumb" :isMost="true" @chooseImg="pickThumb" @closeImgDialog="closeThumbDialog"></imgPicker>
                </el-form-item>
                <el-form-item label="封面图片">
                    <div @click="handleImgPicker('cover_image')" class="upload-box">
                        <img v-if="form.cover_image" :src="form.cover_image" class="avatar"/>
                        <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
                    </div>
                    <div class="frm-tips">只能上传jpg/png文件，且不超过2M</div>
                </el-form-item>

                <el-form-item label="选择视频">
                    <Videoselect @change="handleVideoChange" :data="data[0]"></Videoselect>
                </el-form-item>
                <!--<el-form-item label="商城商品选择">
                    <el-select v-model="relItemsShops" filterable placeholder="请输入商品货号" remote :remote-method="getItemShopsList" @change="handleItemShopsChange" multiple style="width: 55%;">
                        <el-option
                                v-for="item in relItemsShopsList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <div v-show="false">
                        <el-col>
                            <el-input v-model="relItemsShopsVal"></el-input>
                        </el-col>
                    </div>
                </el-form-item>-->
                <el-card header="店铺商品选品" shadow="naver">
                    <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
                </el-card>
                <el-form-item label="奖励规则（积分）">
                  <div v-for="(item, index) in attr_values" :key="index" class="view-flex view-flex-middle key-item" >
                        <el-input v-model="item.attr_values" placeholder="积分值/人" style="width: 15%;"></el-input>
                        <el-select v-model="item.type">
                          <el-option v-for="(item, index) in giftType" :label="item.text" :value="item.rule_type" :key="item.rule_type"></el-option>
                        </el-select>
                        <!-- <el-input v-model="item.type" placeholder="类型" style="width: 10%;"></el-input> -->
                        <el-input v-model="item.time" placeholder="时间/秒" style="width: 15%;"></el-input>
                        <div class="iconfont icon-trash-alt1" @click="removeItem(index)"></div>
                  </div>
                  <el-button type="default" @click="addItem" size="small">添加规则</el-button>
                </el-form-item>
                <el-form-item label="奖励规则（优惠券）">
                  <!-- <div v-for="(item, index) in coupon_values" :key="index" class="view-flex view-flex-middle key-item" > -->

                        <el-button type="default" class="iconfont icon-cog banner-button-uploader" @click="showModal"> 设置优惠券</el-button>

                        <div class="promotion-card-list">
                            <div v-for="(item, index) in coupons.checked" :key="index">
                                <el-button  type="default" class="banner-button-uploader">{{item.title}}</el-button>

                                <i class="remove-btn el-icon-delete" @click="removeChecked(index)"></i>
                            </div>
                        </div>
                        <el-select v-model="coupon_type">
                          <el-option v-for="(item, index) in giftType" :label="item.text" :value="item.rule_type" :key="item.rule_type"></el-option>
                        </el-select>
                        <!-- <el-input v-model = "coupon_type" placeholder="类型" style="width: 10%;"></el-input> -->
                        <el-input v-model = "coupon_time" placeholder="时间/秒" style="width: 15%;"></el-input><!--
                        <div class="iconfont icon-trash-alt1" @click="removeCoupon(index)"></div> -->
                  <!-- </div>
                  <el-button type="default" @click="addCoupon" size="small">添加规则</el-button> -->
                </el-form-item>
                <el-form-item label="奖励规则（红包）">
                  <div v-for="(item, index) in money_values" :key="index" class="view-flex view-flex-middle key-item" >
                        <el-input v-model="item.money_values" placeholder="总金额/元" style="width: 15%;"></el-input>
                        <el-select v-model="item.type">
                          <el-option v-for="(item, index) in giftType" :label="item.text" :value="item.rule_type" :key="item.rule_type"></el-option>
                        </el-select>
                        <el-input v-model="item.time" placeholder="时间/秒" style="width: 15%;"></el-input>
                        <el-input v-model="item.markrting" placeholder="总份额" style="width: 15%;"></el-input>
                        <div class="iconfont icon-trash-alt1" @click="removeMoney(index)"></div>
                  </div>
                  <el-button type="default" @click="addMoney" size="small">添加规则</el-button>
                </el-form-item>
                <el-form-item label="红包开始时间">
                    <el-date-picker
                        v-model="form.end_at"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm"
                        default-time="00:00:00"
                        :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <div class="section-footer with-border content-center">
                    <el-button size="large" @click="cancelSubmit">取消</el-button>
                    <el-button type="primary" @click="submitItemsActionConfirm" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
                </div>
                <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
            </el-form>
            <el-dialog
              title="选择优惠券"
              :visible.sync="coupons.dialog"
              @open="onshowModal"
              @close="oncloseModal"
              width="30%">
              <ul class="dialog-list clearfix" v-loading="coupons.loading">
                <template v-for="item in coupons.list">
                  <li :class="item.checked?'checked':''" @click="selectItems(item)"> <i v-if="item.checked" class="el-icon-check"></i> {{item.title}}</li>
                </template>
              </ul>
              <div class="content-padded">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="changeCouponsPage"
                  :current-page="coupons.page.currentPage"
                  :page-size="coupons.page.pageSize"
                  :total="coupons.page.total">
                </el-pagination>
              </div>
              <div style="display: none;">
                <template v-for="(item, index) in coupons.temp">
                  <li>{{item.title}}</li>
                </template>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelSelected">取 消</el-button>
                <el-button type="primary" @click="submitSelected">确 定</el-button>
              </span>
            </el-dialog>
        </el-card>
    </section>
</template>
<script>
    import { quillEditor } from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import imgPicker from '@/components/imageselect'
    import Videoselect from '@/components/videoselect/index'
    import CouponPicker from '@/components/coupon_picker/index'
    import SkuSelector from '@/components/function/skuSelector'
    import {getDistributorList} from '../../../api/marketing'
    import { getCardList } from '../../../api/cardticket'
    import {deleteVideo, getQiniuVideoList, getUploadQiniuVideoToken, uploadQiniuVideo} from '../../../api/qiniu'
    import {
        saveAnchor,
        getAnchorDetail,
        uploadVideo,
        getShopItemsDetail,
        getLiveConf,
        getCateList,
    } from '../../../api/live'
    import richTextEditor from '@/components/function/richTextEditor'
    export default {
        data () {
            return {
                data: [],
                pickerOptions : {
                    disabledDate (time) {
                        return time.getTime() < Date.now() - 86400000
                    },
                },
                thumbDialog:false,
                isGetThumb: false,
                relItemsShopsList:[],
                submitLoading: false,
                type:1,
                form: {
                    anchor_id:'',
                    cover_image:'',
                    description:'',
                    end_at:'',
                    inca_id:'',
                    is_record:'true',
                    item_bn:'',
                    live_id:'',
                    source_video_type:'',
                    source_video_url:'',
                    title:'',
                    speaker:'',
                    speaker_desc:'',
                    content:'',
                    cate_id:1,
                    sort:0,
                    source_video_type_text:'',
                    distributor_name:'',
                    storeItem:[],
                    shopsItem:[],
                    editorOption:{},
                    videoRules:[],
                },
                sourceVideoTypeOption: [
                    {name: "直播", value: 'live'},
                    {name: "录播", value: 'record'},
                    {name: "上传视频", value: 'upload'},
                ],
                giftType: [
                  { id: 1, text: "时间段", rule_type: '1'},
                  { id: 2, text: "时间点", rule_type: '2'}
                ],
                imgDialog:false,
                isGetImage:false,
                pickerImgType:'cover_image',
                loader:'',
                content:'',
                relItems: [],
                category:[],
                attr_values:[],
                coupon_values:[],
                money_values:[],
                coupondata:[],
                relItemsShops:"",
                relItemsShopsVal:"",
                coupon_id:[],
                coupon_type:'',
                coupon_time:'',
                coupons: {
                  dialog: false,
                  dialog: false,
                  temp: [],
                  list: [],
                  checked: [],
                  page: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 0
                  }
                },
            }
        },
        components: {
            imgPicker,
            SkuSelector,
            Videoselect,
            quillEditor,
        },
        methods: {
            setData(val) {
                this.data = val.data
            },
            handleVideoChange (data) {
                this.$emit('change', data)
                this.form.source_video_url = data.url
            },
            cancelSubmit () {
                this.$router.go(-1)
            },
            submitItemsActionConfirm () {
                this.submitLoading = true
                var newCoupon = this.coupons.checked?this.coupons.checked:'';
                this.submitLoading = true
                var newCoupon = this.coupons.checked?this.coupons.checked:'';
                for (var i = 0; i < this.attr_values.length; i++) {
                    if(this.attr_values[i].attr_values=='')
                    {
                        this.attr_values.splice(i,1)
                        continue
                    }
                }

                for (var i = 0; i < this.money_values.length; i++) {
                    if(this.money_values[i].money_values=='')
                    {
                        this.money_values.splice(i,1)
                        continue
                    }
                }

                var newcoupon  =    [{
                        'coupon_values':newCoupon!=''?newCoupon[0].card_id:'',
                        'coupon_info':newCoupon,
                        'type':this.coupon_type,
                        'time':this.coupon_time
                    }]
                if(newCoupon=='') newcoupon  = ''

                this.form.videoRules = {
                    'integral':this.attr_values,
                    'money':this.money_values,
                    'coupon':newcoupon
                }
                uploadVideo(this.form).then(res => {
                    this.submitLoading = false
                    this.$message({ type: 'success', message: '保存成功'})
                    if (this.$store.getters.login_type != 'distributor') {
                        this.$router.go(-1)
                    }
                }).catch (error => {
                    this.submitLoading = false
                })
            },
            typeSel:function(){
                getCateList({page:1,pageSize:-1,type:this.type}).then(res=>{
                    if(res.data){
                        this.category = res.data.data.list
                    }
                })
            },
            addImgPreview: function () {
                this.thumbDialog = true
                this.isGetThumb = true
            },
            closeThumbDialog: function () {
                this.thumbDialog = false
            },
            updateContent: function (data) {
                this.form.content = data
            },
            pickThumb: function (arr) {
                if (arr.length != 0) {
                  arr.forEach(data => {
                    if (data && data.url !== '') {
                      this.thumbDialog = false
                      var index = this.$refs.editor.$el.id
                      var loc = this.$refs.editor
                      var img = new Image()
                      img.src = this.wximageurl + data.url
                      if (loc.range) {
                        loc.range.insertNode(img)
                        var referenceNode = loc.range.endContainer
                        if (referenceNode.className !== 'content') {
                          loc.range.setStartAfter(referenceNode)
                        } else {
                          loc.range.setStart(loc.range.endContainer, loc.range.endOffset)
                        }
                      } else {
                        loc.$refs.content.appendChild(img)
                        loc.focus()
                        loc.restoreSelection()
                      }
                      this.form.content = loc.$refs.content.innerHTML
                    }
                  })
                }
              },
            pickImg (data) {
                if (this.pickerImgType == 'cover_image') {
                    this.form.cover_image = data.url
                }
                this.imgDialog = false
            },
            handleImgPicker(pickerImgType) {
                this.pickerImgType = pickerImgType
                this.imgDialog = true
                this.isGetImage = true
            },
            closeImgDialog () {
                this.imgDialog = false
                this.isGetImage = false
            },
            handleVideoTypeChange:function (val){
                this.form.source_video_type = val
            },
            getItems(data) {
                let items = []
                data.forEach(item => {
                    items.push(item.itemId)
                })
                this.form.storeItem = items
            },
            getCoupon(data) {
                let items = []
                data.forEach(item => {
                    items.push(item.itemId)
                })
                this.form.storeItem = items
            },
            getItemShopsList(val){
                getShopItemsDetail({page: 1, pageSize: 50,id:val}).then(res => {
                    this.relItemsShopsList = [];
                    for (let item of res.data.data.list) {
                        this.relItemsShopsList.push({name: item.item_name, id: item.item_id})
                    }
                })
            },
            handleItemShopsChange:function (val){
                this.form.shopsItem = val
            },
            addItem() {

                if (this.attr_values.length > 20) {
                  this.$message({ type: 'warning', message: '最多添加20项'})
                  return
                }

                let item = {
                  attr_values: '',
                  type: '',
                  time: ''
                }


                this.attr_values.push(item)
               return
            },
            removeItem(index) {
                this.$confirm('确认删除当前值？')
                  .then(_ => {
                    this.attr_values.splice(index, 1)
                  })
                  .catch(_ => {});
            },

            addMoney() {

                if (this.money_values.length > 20) {
                  this.$message({ type: 'warning', message: '最多添加20项'})
                  return
                }

                let item = {
                  money_values: '',
                  type: '',
                  time: '',
                  markrting: ''
                }
                this.money_values.push(item)

            },
            removeMoney(index) {
                this.$confirm('确认删除当前值？')
                  .then(_ => {
                    this.money_values.splice(index, 1)
                  })
                  .catch(_ => {});
            },
            showModal() {
                this.coupons.dialog = true
            },
            onshowModal() {
                this.coupons.loading = true
                for (var i = 0; i < this.coupons.checked.length; i++) {
                  this.coupons.temp.push(this.coupons.checked[i])
                }
                this.getCoupons(this.coupons.page.currentPage)
            },
            changeCouponsPage(currentPage) {
                this.coupons.page.currentPage = currentPage
                this.getCoupons(currentPage)
            },
            oncloseModal() {
                this.coupons.temp = []
            },
            selectItems(item)
            {
                if (item.checked) {
                    for (var i = 0; i < this.coupons.temp.length; i++) {
                        if (this.coupons.temp[i].card_id === item.card_id) {
                            this.coupons.temp.splice(i,1)
                        }
                    }
                    for (var i = 0; i < this.coupons.list.length; i++) {
                        if (this.coupons.list[i].card_id === item.card_id)
                        {
                            this.coupons.list[i].checked = false
                        }
                    }
                } else{
                    for (var i = 0; i < this.coupons.list.length; i++) {
                        if (this.coupons.list[i].card_id === item.card_id) {
                            this.coupons.list[i].checked = true
                        }
                    }
                    this.coupons.temp.push(item)
                }
            },
            getCoupons(current) {
                getCardList({
                  page_no: current,
                  page_size: this.coupons.page.pageSize,
                  term:1
                }).then( res => {
                  var data = res.data.data.list
                  for (var i = 0; i < data.length; i++) {
                    for (var j = 0; j < this.coupons.checked.length; j++) {
                      if (data[i].card_id === this.coupons.checked[j].card_id) {
                        data[i].checked = true
                      }
                    }
                  }
                  this.coupons.list = data
                  this.coupons.page.total = res.data.data.pagers.total
                  this.coupons.loading = false
                })
            },
            save () {
                this.form.promotions_value.itemsList = []
                let couponArr = []
                for (var i = 0; i < this.coupons.checked.length; i++) {
                  let couponObj = {}
                  couponObj.card_id = this.coupons.checked[i].card_id
                  couponObj.count = this.coupons.checked[i].count
                  couponObj.title = this.coupons.checked[i].title
                  couponArr.push(couponObj)
                }
                this.form.promotions_value.coupons = couponArr
                this.goodsList.forEach(row => {
                  let index = this.form.promotions_value.items.indexOf(row.key)
                  //如果选中
                  if(index !== -1) {
                    this.form.promotions_value.itemsList.push(row)
                  }
                })
                saveRegisterPromotions(this.form).then(res => {
                  this.$message({
                    message: '保存成功',
                    type: 'success',
                    duration: 5 * 1000
                  })
                })
            },
            submitSelected() {
                this.coupons.dialog = false
                this.coupons.checked = this.coupons.temp
                for (var i = 0; i < this.coupons.checked.length; i++) {
                  this.coupons.checked[i].count = 1
                }
                this.coupons.temp = []
            },

            cancelSelected() {
                this.coupons.dialog = false
                this.coupons.temp = []
            },
            removeChecked(type, index) {
                this.coupons.checked.splice(index, 1)
              },
            },
            mounted () {
                getLiveConf().then(res=>{
                    if(res.data.is_open==1){
                        this.$confirm('目前红包未开放，确认继续操作', '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning'
                        }).then(() => {

                        }).catch(() => {
                          this.$router.go(-1);
                        });
                    }
                    if(res.data){
                        this.sourceVideoTypeOption = res.data.source_video_type
                    }
                })
                getCateList({page:1,pageSize:-1,type:this.type}).then(res=>{
                    if(res.data){
                        this.category = res.data.data.list
                        this.type = res.data.data.list[0].type
                    }
                })
                this.anchor_id = this.$route.params.id
                getAnchorDetail(this.$route.params).then(res => {
                    if(res.data){
                        if(this.anchor_id){
                            this.is_new = false;
                        }
                        res.data.data.disabled = res.data.data.disabled ?  '1' : '0';
                        this.form = res.data.data
                        this.form.source_video_type_text = '视频上传'
                        this.form.source_video_type = 'upload'
                    }
                });

            },


    }
</script>

<style lang="scss">
    .bm-view {
        width: 100%;
        height: 300px;
    }
    #qqmap_rslist {
        border-right: 1px solid #e7e7eb;
    }
    #qqmap_container{
        float:left;
        width:800px;
        height:400px;
    }
    .checkbox {
        background-color: white;
        border-radius: 0px;
        border: 1px solid #d3d3d3;
        width: 20px;
        height: 20px;
        display: inline-block;
        text-align: center;
        vertical-align: bottom;
        line-height: 20px;
    }
    .upload-box {
        width: 120px;
        height: 120px;
        .el-upload {
            width: 100%;
            height: 100%;
        }
    }
    .upload-box .avatar-uploader-icon {
        line-height: 120px;
        color: #cccccc;
    }
    .upload-box .avatar-uploader-icon {
        font-size: 30px;
    }
</style>



// WEBPACK FOOTER //
// uploadvideo.vue?e98772f8